












import {Component, Prop, Vue} from 'vue-property-decorator';
import ClaimsDialog from '@/components/ClaimsDialog.vue';
import {CLAIM_STATUS, nil} from '@/common';
import {DateTime} from 'luxon';

@Component({
    components: {
    },
})
export default class VendorClaimTooltip extends Vue {
    //// @click="$router.push(`./bookings/${booking._id}`)"
    @Prop({default: false})
    public loading!: boolean;

    @Prop({default: () => null})
    public booking!: any;

    @Prop({default: () => []})
    public claims!: any[];

    get tooltipText() {
        if (this.booking == null) { return ''; }
        const {_id, requestedVendor, assignedVendor, vendorClaimStatus} = this.booking;
        const claimant = null;

        if (this.isInMissingClaimsErrorState) {
            return 'No Pros Notified of this booking';
        }

        let message = `No Pros claimed this booking, ${this.claims.length} have been notified.`;
        if (this.isInAcceptedErrorState) {
            message = `ERROR! Multiple vendors have accepted - please reconcile`;
        } else if (this.isInAcceptedState) {
            const {firstName, lastName, email} = this.booking.assignedVendorModel;
            const relativeDate = DateTime.fromISO(this.acceptedClaims[0].updatedAt).toLocal().toLocaleString(DateTime.DATETIME_MED);
            message = `Claim accepted by ${firstName} ${lastName} ${relativeDate}`;
        } else if (this.isInRejectedState) {
            message = `${this.rejectedClaims.length}/${this.claims.length} Pros rejected booking`;
        } else if (this.isInAssignedState) {
            const {firstName, lastName, email} = this.booking.assignedVendorModel;
            message = `Manually assigned ${firstName} ${lastName}`;
        }
        return message;
    }

    get acceptedClaims() {
        return this.claims.filter((x) => x.status === CLAIM_STATUS.ACCEPTED);
    }

    get rejectedClaims() {
        return this.claims.filter((x) => x.status === CLAIM_STATUS.REJECTED);
    }

    get unknownClaims() {
        return this.claims.filter((x) => x.status === CLAIM_STATUS.UNKNOWN);
    }
    get assignedClaims() {
        return this.claims.filter((x) => x.status === CLAIM_STATUS.ASSIGNED);
    }

    get isInUnknownState() {
        return !this.isInAssignedState && this.acceptedClaims.length === 0 && this.rejectedClaims.length === 0;
    }

    get isInRejectedState() {
        return this.rejectedClaims.length > 0 && this.acceptedClaims.length === 0;
    }

    get isInAssignedState() {
        return this.assignedClaims.length === 1;
    }

    get isInAcceptedState() {
        return this.acceptedClaims.length === 1;
    }

    get isInAcceptedErrorState() {
        return this.acceptedClaims.length > 1;
    }

    get isInMissingClaimsErrorState() {
        return nil(this.claims) || this.claims.length === 0;
    }
}
